import { FlexRow, FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { GenderDistribution } from "app/pages/website-analysis/demographicsUserBased/genderDistribution/GenderDistribution";
import { AgeDistribution } from "app/pages/website-analysis/demographicsUserBased/ageDistribution/AgeDistribution";
import { useEffect, useMemo, useState } from "react";
import type { IRawData } from "app/pages/website-analysis/demographicsUserBased/utils/fetchData";
import { fetchData, getExcelLink } from "app/pages/website-analysis/demographicsUserBased/utils/fetchData";
import { parseRawAgeRations } from "app/pages/website-analysis/demographicsUserBased/utils/parseRawAgeRations";
import { TrafficAndEngagementTable } from "app/pages/website-analysis/demographicsUserBased/trafficAndEngagmentTable/TrafficAndEngagementTable";

export const DemographicsUserBasedSingle = () => {
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [rawData, setRawData] = useState<IRawData>({});
    useEffect(() => {
        setIsLoading(true);
        fetchData()
            .then(setRawData)
            .finally(() => setIsLoading(false));
    }, []);
    const rawSiteData = Object.values(rawData)[0];
    const femalesRatio = rawSiteData?.FemalesRatio;
    const ageDistribution = parseRawAgeRations(rawSiteData?.AgeRatios);
    const downloadExcelUrl = useMemo(() => getExcelLink(), []);

    return (
        <FlexColumn gap={"20px"}>
            <FlexRow>
                <GenderDistribution
                    isLoading={isLoading}
                    femalesRatio={femalesRatio}
                    downloadExcelUrl={downloadExcelUrl}
                />
                <AgeDistribution
                    isLoading={isLoading}
                    ageDistribution={ageDistribution}
                    downloadExcelUrl={downloadExcelUrl}
                />
            </FlexRow>
            <TrafficAndEngagementTable />
        </FlexColumn>
    );
};
